import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { ThemeProvider } from "@fluentui/react";
import { M365ActualLightTheme } from "@m365-admin/customizations";
import { Provider } from "react-redux";
import { msalConfig } from "./authConfig";
import Login from "./login";
import { store } from "./store/store";

// Create and export MSAL instance - initialization happens in index.js before rendering
export const msalInstance = new PublicClientApplication(msalConfig);

const App = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={M365ActualLightTheme}>
        <Provider store={store}>
          <Login />
        </Provider>
      </ThemeProvider>
    </MsalProvider>
  );
};

export default App;
